module.exports = __webpack_public_path__ + "static/wonder_woman_1984_4320x1080-tablet.66fccc09.png";